<template>
  <v-container class="pt-5">
      <challenger :item="challenger" :show-bio="false" />
      <component v-if="challenger.component" :is="challenger.component"></component>
      <v-layout row wrap>
          <v-flex xs12 offset-md2 md8>
              <p class="text-xs-justify pt-4 book menu-text" v-html="challenger.bioLong">
              </p>
              <p class="text-xs-justify pt-4 book menu-text" v-html="challenger.bioLongSara">
              </p>
              <div class="text-xs-center">
                  <a :href="challenger.fbLinkSara" target="_blank" v-if="challenger.fbLinkSara">
                      <img src="/static/facebook-icon.png" class="d-inline-block pr-2"/>
                  </a>
                  <a :href="challenger.instagramLinkSara" target="_blank" v-if="challenger.instagramLinkSara">
                      <img src="/static/instagram-icon.png" class="d-inline-block" :class="{'pr-2': challenger.ownUrlSara}"/>
                  </a>
                  <a :href="challenger.ownUrlSara" target="_blank" class="no-decoration" v-if="challenger.ownUrlSara">
                      <v-icon medium>launch</v-icon>
                  </a>
              </div>
              <p class="text-xs-justify pt-4 book menu-text" v-html="challenger.bioLongTomas">
              </p>
              <div class="text-xs-center">
                  <a :href="challenger.fbLinkTomas" target="_blank" v-if="challenger.fbLinkTomas">
                      <img src="/static/facebook-icon.png" class="d-inline-block pr-2"/>
                  </a>
                  <a :href="challenger.instagramLinkTomas" target="_blank" v-if="challenger.instagramLinkTomas">
                      <img src="/static/instagram-icon.png" class="d-inline-block" :class="{'pr-2': challenger.ownUrlTomas}"/>
                  </a>
                  <a :href="challenger.ownUrlTomas" target="_blank" class="no-decoration" v-if="challenger.ownUrlTomas">
                      <v-icon medium>launch</v-icon>
                  </a>
              </div>
          </v-flex>
      </v-layout>
      <v-layout row wrap class="text-xs-center pt-5">
          <v-flex xs12 offset-xl2 xl8>
              <v-layout row wrap align-center justify-center fill-height class="pb-5 pt-5">
                  <v-flex xs12 md4 v-for="image in challenger.images" :key="image.id">
                      <img :src="'/static/' + image.img" :srcset="'/static/' + image.retina + ' 2x'" />
                  </v-flex>
              </v-layout>
              <v-divider></v-divider>
          </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
  import Challenger from '../components/Challenger'
  import SarkaRakosnikova from '../components/ChallengerComponents/SarkaRakosnikova'

  export default {
    components: {
        Challenger,
        SarkaRakosnikova
    },
    mounted () {
      let challenger = this.$router.currentRoute.params.alias;
      if (this.$store.state.challengers[challenger]) {
        this.challenger = this.$store.state.challengers[challenger];
      } else {
        this.$router.push('/');
      }
    },
    data () {
      return {
          challenger: {},
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Challenger.vue